import "./_MagazineLinkCard.scss";
import { NavLink, useLocation } from "react-router-dom";
import { FC } from "react";
import { MagzineResponseModel } from "../../../interfaces/models/magazineModels/MagazineResponse.model";
import { convertDateFormat } from "../../../utils/covertDateFormat";
import { useTranslation } from "react-i18next";

const MagazineLinkCard: FC<MagzineResponseModel> = ({
  id,
  insertedDate,
  cover,
  editorialNumber,
  description,
  embeddedCode,
  tags,
  inDashboard = false,
  title,
  hasQuizes,
  magazinePath,
}) => {
  const { t } = useTranslation();
  const location = useLocation();

  const locationPath = location.pathname.toString().split("/:")[0];
  const adminPath = location.pathname.includes("dashboard");

  const showEmbeddedHTML = () => {
    const newWindow = window.open("", "_blank");
    if (newWindow) {
      newWindow.document.write(`
        <html>
          <head>
            <title>Patro - ${title}</title>
            <link rel="icon" type="image/x-icon" href="https://revuelepatro.be/favicon.ico" />
          </head>
          <body>
            <div>${embeddedCode}</div>
          </body>
        </html>
      `);
      newWindow.document.close();
      newWindow.history.pushState({}, "", `/magazine-read/${id}`);
    }
  };

  // Alternative approach
  // const redirectToEmbeddedHTML = () => {
  //   navigate(`/magazine-read/${id}`);
  // };

  const cardContent = (
    <>
      <img src={cover} alt={`${title} magazine cover`} />
      <div className="magazineLinkCard-content">
        <div className="magazineLinkCard-content-part1">
          <p className="magazineLinkCard-date">
            <>
              {editorialNumber} <span></span>{" "}
              {convertDateFormat(insertedDate).date}
            </>
          </p>
          <h3 className="magazineLinkCard-title">{title}</h3>
          <p className="magazineLinkCard-description">{description}</p>
        </div>
        <div className="magazineLinkCard-tags">
          {tags?.map((tag, index) => {
            let color = Math.floor(Math.random() * 16777215).toString(16);
            return (
              <div
                className="tag"
                key={index}
                style={{
                  color: `#${color}`,
                  border: `1px solid #${color}`,
                }}
              >
                {tag}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );

  return (
    <>
      {magazinePath && !adminPath ? (
        <a
          href={magazinePath}
          target="_blank"
          className="magazineLinkCard"
          rel="noreferrer"
        >
          {cardContent}
        </a>
      ) : embeddedCode && !inDashboard ? (
        <div
          className="magazineLinkCard"
          onClick={showEmbeddedHTML}
          style={{
            cursor: "pointer",
          }}
        >
          {cardContent}
        </div>
      ) : (
        <NavLink
          to={locationPath === "/" ? `magazines/${id}` : `${id}`}
          className="magazineLinkCard"
        >
          {cardContent}
        </NavLink>
      )}
    </>
  );
};

export default MagazineLinkCard;
